module.exports = __webpack_public_path__ + "img/ruoyi2.b59aaf89.png";